// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__3-Nlg","password":"PasswordResetForm_password__eEz4P"};